import React from 'react';
import { loginBodyBg, nameLogo, plainLogo } from '../res/images';
import { LoginForm } from '../whealth-core-web/login';

function loginScene() {
  return <LoginForm logo={plainLogo} background={loginBodyBg} nameLogo={nameLogo} />;
}

export default loginScene;
